import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Modal from 'react-bootstrap/lib/Modal';
import classnames from 'classnames';
import { injectIntl, FormattedMessage } from 'react-intl';
import intlShape from '@/shared/utils/intlShape';
import Button from '@/shared/components/Button';
import api from '@/shared/api';
import config from '@/config';
import handleHttpError from '@/shared/services/HandleHttpError';
import messages from './assignmentTemplateMessages';

class AddTaskTemplateModal extends Component {
  constructor(props) {
    super(props);
    const { assignmentTemplateId } = props;
    this.state = {
      template: {
        assignmentTemplateId,
        taskTemplateId: null,
        taskPeriodicityId: null,
      },
      showValidation: false,
      saving: false,
    };
  }

  save = () => {
    const { saving, template } = this.state;
    const { onClose } = this.props;
    if (!this.isValid() || saving) return '';
    this.setState({ saving: true });

    return api.base
      .post(`${config.appUrls.tasks}/api/AssignmentTemplate`, template)
      .then(
        ({ data }) => {
          if (!data) return '';

          onClose(data);
          return data;
        },
        error => {
          const { intl } = this.props;
          handleHttpError(intl)(error);
          return error;
        },
      )
      .finally(() => {
        if (typeof this !== 'undefined') this.setState({ saving: false });
      });
  };

  updateTemplate = changes => {
    this.setState(({ template }) => ({ template: { ...template, ...changes } }));
  };
  showValidation = () => {
    const { showValidation } = this.state;
    if (!showValidation) this.setState({ showValidation: true });
  };

  isValid = () => {
    const { template } = this.state;
    return !!template.taskTemplateId;
  };
  render() {
    const { onClose, intl, taskTemplates } = this.props;
    const { template, showValidation, saving } = this.state;

    const isValid = this.isValid();
    const selectedTaskTemplate = template.taskTemplateId
      ? taskTemplates.find(x => x.id === template.taskTemplateId)
      : null;
    const { periodicities = [] } = selectedTaskTemplate || {};

    return (
      <Modal backdrop="static" show onHide={() => onClose(null)} keyboard={false}>
        <Modal.Header closeButton>
          <Modal.Title>
            <FormattedMessage {...messages.AddTaskTemplate} />
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="form-horizontal">
            <div
              className={classnames('form-group', {
                'has-error': showValidation && !template.taskTemplateId,
              })}
            >
              <label className="control-label col-sm-4">
                <FormattedMessage {...messages.TaskTemplate} />
              </label>
              <div className="col-sm-8">
                <select
                  className="form-control"
                  value={template.taskTemplateId || ''}
                  required
                  onChange={e =>
                    this.updateTemplate({ taskTemplateId: e.target.value, taskPeriodicityId: null })
                  }
                >
                  {!template.taskTemplateId && (
                    <option value="">{intl.formatMessage(messages.SelectTaskTemplate)}</option>
                  )}
                  {taskTemplates.map(task => (
                    <option key={task.id} value={task.id}>
                      {task.label}
                    </option>
                  ))}
                </select>
              </div>
            </div>
            {periodicities && periodicities.length > 0 && (
              <div className="form-group">
                <label className="control-label col-sm-4">
                  <FormattedMessage {...messages.DefaultTaskPeriodicity} />
                </label>
                <div className="col-sm-8">
                  <select
                    className="form-control"
                    value={template.taskPeriodicityId || ''}
                    required
                    onChange={e =>
                      this.updateTemplate({
                        taskPeriodicityId: e.target.value || null,
                      })
                    }
                  >
                    <option value="">{intl.formatMessage(messages.NoDefault)}</option>
                    {periodicities.map(per => (
                      <option key={per.id} value={per.id}>
                        {per.label}
                      </option>
                    ))}
                  </select>
                </div>
              </div>
            )}
          </div>
        </Modal.Body>
        <Modal.Footer>
          <Button disabled={saving} onClick={() => onClose(null)}>
            <FormattedMessage {...messages.Cancel} />
          </Button>
          <Button
            onClick={() => this.save()}
            disabled={showValidation && !isValid}
            onFocus={this.showValidation}
            onMouseOver={this.showValidation}
            btnClassName="btn-inverse"
            showProgress
          >
            <FormattedMessage {...messages.Add} />
          </Button>
        </Modal.Footer>
      </Modal>
    );
  }
}

AddTaskTemplateModal.propTypes = {
  intl: intlShape.isRequired,
  onClose: PropTypes.func.isRequired,
  assignmentTemplateId: PropTypes.string.isRequired,
  taskTemplates: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string.isRequired,
      label: PropTypes.string.isRequired,
      periodicities: PropTypes.arrayOf(
        PropTypes.shape({
          id: PropTypes.string.isRequired,
          label: PropTypes.string.isRequired,
        }),
      ),
    }),
  ).isRequired,
};

export default injectIntl(AddTaskTemplateModal);
